module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-ties-remnants.59d4b66f.png";